export default {"src":"/uk/_next/static/media/supportIcon.c3d5d0a8.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};